<template>
  <div class="section-adsblock">
    <Section>
      <div class="section-header" slot="header">
        <h1 class="title">Ads Block</h1>
      </div>
      <div class="section-body">
        <div class="row">
          <div v-if="!isLoading && !isEmpty" class="col-12 col-sm-12">
            <SideGraphInfo :data="adsData" />
            <div class="progress-container">
              <div class="progress">
                <div
                  class="progress-bar"
                  role="progressbar"
                  :style="{'width': this.adsBlockPercentage() + '%', 'background': '#eb5757 !important', 'color': ''}"
                  aria-valuenow="3"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </div>
            <div class="slide-container">
              <div class="arrow-up" :style="{'margin-left': this.adsBlockPercentage() - 1 + '%'}"></div>
              <div
                class="slice"
                :style="{'margin-left': this.adsBlockPercentage() - 4 + '%'}"
              >{{this.adsBlockPercentage()}} %</div>
            </div>
          </div>
          <EmptyMessage v-if="!isLoading && isEmpty && !isError">
            ไม่พบข้อมูลในช่วงเวลาดังกล่าว
          </EmptyMessage>
          <EmptyMessage v-if="!isLoading && isError">
            <h3>พบข้อผิดพลาดระหว่างโหลดข้อมูล</h3>
            <p>
              โปรดรอซักครู่เพื่อโหลดข้อมูลใหม่ หรือติดต่อ
              <a
                :href="`mailto:support@byteark.com`"
                target="_top"
              >support@byteark.com</a>
            </p>
            <span slot="code" class="code">error code : {{error.status || 'not found' }} </span>
          </EmptyMessage>
          <div v-if="isLoading" class="d-flex justify-content-center">
            <div class="spinner-border" role="status" />
          </div>
        </div>
      </div>
    </Section>
  </div>
</template>

<script>
/* eslint-disable operator-linebreak */

import _ from 'lodash';

import SideGraphInfo from '@/performance/SideGraphInfo.vue';
import Section from '@/components/Section.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';

export default {
  props: ['adsData', 'isLoading', 'isError', 'error'],
  components: {
    SideGraphInfo,
    Section,
    EmptyMessage,
  },
  watch: {
    adsData() {
      this.mapGraphData();
    },
  },
  computed: {
    isAdsGraphEmpty() {
      return _.isEmpty(this.adsData.total_play);
    },
    isAdsDataEmpty() {
      return _.isEmpty(this.adsData);
    },
    totalPlay() {
      return _.get(this.adsData, 'total_play', 0);
    },
    adsBlocked() {
      return _.get(this.adsData, 'ad_block', 0);
    },
    isEmpty() {
      return _.isEmpty(this.adsData);
    },
  },
  data() {
    return {
      colors: ['#008FFB', '#FEB019'],
      series: null,
      labels: null,
    };
  },
  created() {},
  methods: {
    totalPlayPercentage() {
      return (
        (this.totalPlay / (this.totalPlay + this.adsBlocked)) *
        100
      ).toFixed(2);
    },
    adsBlockPercentage() {
      return (
        (this.adsBlocked / (this.totalPlay + this.adsBlocked)) *
        100
      ).toFixed(2);
    },
    mapGraphData() {
      const series = [this.adsData.total_play, this.adsData.ad_block];
      const labels = ['Total Played', 'Ad Block'];
      this.series = _.cloneDeep(series);
      this.labels = _.cloneDeep(labels);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/themes/components/section.scss';

.label-progress-container {
  display: flex;
  margin: 0;

  .label-right {
    margin-left: auto;
  }
}

.slide-container {
  margin: 0 $spacer;
}

.progress-container {
  margin: $spacer;

  .bg-primary {
    color: #eb5757 !important;
  }
}

.slice {
  width: $spacer * 4;
  padding: $spacer / 2 $spacer / 2;
  background: $gray-600;
  border-radius: 2px;
  background: #eb5757;
  color: $white;
  text-align: center;
}

.arrow-up {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;

  border-bottom: 5px solid #eb5757;
}

.progress {
  height: $spacer * 4;
  border-radius: 0;
}

.section-adsblock {
  .section {
    min-height: 400px;
  }
}

.ads-block {
  background: #feb019 !important;
}

.total-play {
  background: #008ffb !important;
}

@media (min-width: 320px) and (max-width: 767.98px) {
  .section-adsblock {
    .section {
      min-height: 300px !important;
      height: 100%;
    }
  }

  .progress {
    height: $spacer * 2;
  }

  .progress-container {
    margin-bottom: $spacer / 2;
  }

  .slide-container {
    margin: $spacer / 2 0;
  }

  .progress-container {
    margin: $spacer / 2 0;
  }
}

@media (min-width: 768px) and (max-width: 1199.98px) {
  .progress {
    height: $spacer * 3;
  }

  .progress-container {
    margin-bottom: $spacer / 2;
  }

  .slide-container {
    margin: $spacer / 2 0;
  }

  .progress-container {
    margin: $spacer / 2 0;
  }
}
</style>
